export default function PolitiquesDeConfidentialite() {
  return (
    <div className="max-width-blue-section">
      <h2 className="mb-20 text-center">Mentions légales et politique de confidentialité</h2>

      <p>
        Mentions légales et politique de confidentialité. La société Zèle Solutions, soucieuse des
        droits des individus, notamment au regard des traitements automatisés et dans une volonté de
        transparence avec ses clients, a mis en place une politique reprenant l’ensemble de ces
        traitements, des finalités poursuivies par ces derniers ainsi que des moyens d’actions à la
        disposition des individus afin qu’ils puissent au mieux exercer leurs droits. Pour toute
        information complémentaire sur la protection des données personnelles, nous vous invitons à
        consulter le site :{' '}
        <a className="text-link" href="https://www.cnil.fr//" rel="noreferrer" target="_blank">
          https://www.cnil.fr//
        </a>
        . La poursuite de la navigation sur ce site vaut acceptation sans réserve des dispositions
        et conditions d&apos;utilisation qui suivent. La version actuellement en ligne de ces
        conditions d&apos;utilisation est la seule opposable pendant toute la durée
        d&apos;utilisation du site et jusqu&apos;à ce qu&apos;une nouvelle version la remplace.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 1 - Mentions légales</h3>
      <h4 className="mt-4 mb-4">1.1 Site (ci-après « le site ») :</h4>
      <p>zLawyer</p>

      <h4 className="mt-4 mb-4">1.2 Éditeur (ci-après « l&apos;éditeur ») :</h4>
      <p>
        Zèle Solutions SARL au capital de 3 000 € dont le siège social est situé : 9 rue Angélique
        Verien 92200 Neuilly-sur-Seine représentée par Frédéric Courquin, en sa qualité de Gérant
        immatriculée au RCS de Paris 498 687 920.
      </p>
      <br />
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>
          n° de téléphone :{' '}
          <a className="text-link" href="tel:330184257027">
            01 84 25 70 27
          </a>
        </li>
        <li>
          adresse mail :{' '}
          <a className="text-link" href="mailto:contact@zele-solutions.fr">
            contact@zele-solutions.fr
          </a>
        </li>
      </ul>

      <h4 className="mt-4 mb-4">1.3 Hébergeur (ci-après « l&apos;hébergeur ») :</h4>
      <p>
        zLawyer est hébergé par Microsoft Azure, dont le siège social est situé en Europe
        occidentale.
      </p>

      <h4 className="mt-4 mb-4">1.4 Délégué à la protection des données (DPO) :</h4>
      <p>
        Un délégué à la protection des données : Frédéric Courquin,{' '}
        <a className="text-link" href="mailto:fcourquin@zele-solutions.fr">
          fcourquin@zele-solutions.fr
        </a>
        , est à votre disposition pour toute question relative à la protection de vos données
        personnelles.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 2 - Accès au site</h3>
      <p>
        L&apos;accès au site et son utilisation sont réservés à un usage strictement personnel. Vous
        vous engagez à ne pas utiliser ce site et les informations ou données qui y figurent à des
        fins commerciales, politiques, publicitaires et pour toute forme de sollicitation
        commerciale et notamment l&apos;envoi de courriers électroniques non sollicités.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 3 - Contenu du site</h3>
      <p>
        Toutes les marques, photographies, textes, commentaires, illustrations, images animées ou
        non, séquences vidéo, sons, ainsi que toutes les applications informatiques qui pourraient
        être utilisées pour faire fonctionner ce site et plus généralement tous les éléments
        reproduits ou utilisés sur le site sont protégés par les lois en vigueur au titre de la
        propriété intellectuelle. Ils sont la propriété pleine et entière de l&apos;éditeur ou de
        ses partenaires. Toute reproduction, représentation, utilisation ou adaptation, sous quelque
        forme que ce soit, de tout ou partie de ces éléments, y compris les applications
        informatiques, sans l&apos;accord préalable et écrit de l&apos;éditeur, sont strictement
        interdites. Le fait pour l&apos;éditeur de ne pas engager de procédure dès la prise de
        connaissance de ces utilisations non autorisées ne vaut pas acceptation desdites
        utilisations et renonciation aux poursuites.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 4 - Gestion du site</h3>
      <p>Pour la bonne gestion du site, l&apos;éditeur pourra à tout moment :</p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>
          suspendre, interrompre ou limiter l&apos;accès à tout ou partie du site, réserver
          l&apos;accès au site, ou à certaines parties du site, à une catégorie déterminée
          d&apos;internautes ;
        </li>
        <li>
          supprimer toute information pouvant en perturber le fonctionnement ou entrant en
          contravention avec les lois nationales ou internationales ;
        </li>
        <li>suspendre le site afin de procéder à des mises à jour.</li>
      </ul>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 5 - Responsabilités</h3>
      <p>
        La responsabilité de l&apos;éditeur ne peut être engagée en cas de défaillance, panne,
        difficulté ou interruption de fonctionnement, empêchant l&apos;accès au site ou à une de ses
        fonctionnalités. Le matériel de connexion au site que vous utilisez est sous votre entière
        responsabilité. Vous devez prendre toutes les mesures appropriées pour protéger votre
        matériel et vos propres données notamment d&apos;attaques virales par Internet. Vous êtes
        par ailleurs seul responsable des sites et données que vous consultez. L&apos;éditeur ne
        pourra être tenu responsable en cas de poursuites judiciaires à votre encontre :
      </p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>du fait de l&apos;usage du site ou de tout service accessible via Internet ;</li>
        <li>du fait du non-respect par vous des présentes conditions générales.</li>
      </ul>

      <br />

      <p>
        L&apos;éditeur n&apos;est pas responsable des dommages causés à vous-même, à des tiers et/ou
        à votre équipement du fait de votre connexion ou de votre utilisation du site et vous
        renoncez à toute action contre lui de ce fait. Si l&apos;éditeur venait à faire l&apos;objet
        d&apos;une procédure amiable ou judiciaire en raison de votre utilisation du site, il pourra
        se retourner contre vous pour obtenir l&apos;indemnisation de tous les préjudices, sommes,
        condamnations et frais qui pourraient découler de cette procédure.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 6 - Liens hypertextes</h3>
      <p>
        La mise en place par les utilisateurs de tous liens hypertextes vers tout ou partie du site
        est strictement interdite, sauf autorisation préalable et écrite de l&apos;éditeur.
        L&apos;éditeur est libre de refuser cette autorisation sans avoir à justifier de quelque
        manière que ce soit sa décision. Dans le cas où l&apos;éditeur accorderait son autorisation,
        celle-ci n&apos;est dans tous les cas que temporaire et pourra être retirée à tout moment,
        sans obligation de justification à la charge de l&apos;éditeur. Toute information accessible
        via un lien vers d&apos;autres sites n&apos;est pas publiée par l&apos;éditeur.
        L&apos;éditeur ne dispose d&apos;aucun droit sur le contenu présent dans ledit lien.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 7 - Collecte et protection des données</h3>
      <p>
        Vos données sont collectées par la société Zèle Solutions. Une donnée à caractère personnel
        désigne toute information concernant une personne physique identifiée ou identifiable
        (personne concernée) ; est réputée identifiable une personne qui peut être identifiée,
        directement ou indirectement, notamment par référence à un nom, un numéro
        d&apos;identification ou à un ou plusieurs éléments spécifiques, propres à son identité
        physique, physiologique, génétique, psychique, économique, culturelle ou sociale. Les
        informations personnelles pouvant être recueillies sur le site sont principalement utilisées
        par l&apos;éditeur pour la gestion des relations avec vous, et le cas échéant pour le
        traitement de vos commandes. Les données personnelles collectées sont les suivantes :
      </p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>nom et prénom</li>
        <li>adresse</li>
        <li>adresse mail</li>
        <li>numéro de téléphone</li>
      </ul>
      <br />
      <p>
        Un délégué à la protection des données : Frédéric Courquin,{' '}
        <a className="text-link" href="mailto:fcourquin@zele-solutions.fr">
          fcourquin@zele-solutions.fr
        </a>
        , est à votre disposition pour toute question relative à la protection de vos données
        personnelles.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">
        Article 8 - Droit d’accès, de rectification et de déréférencement de vos données
      </h3>
      <p>
        En application de la réglementation applicable aux données à caractère personnel, les
        utilisateurs disposent des droits suivants :
      </p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>
          le droit d’accès : ils peuvent exercer leur droit d&apos;accès, pour connaître les données
          personnelles les concernant, en écrivant à l&apos;adresse électronique ci-dessous
          mentionnée. Dans ce cas, avant la mise en œuvre de ce droit, la Plateforme peut demander
          une preuve de l&apos;identité de l&apos;utilisateur afin d&apos;en vérifier
          l&apos;exactitude ;
        </li>
        <li>
          le droit de rectification : si les données à caractère personnel détenues par la
          Plateforme sont inexactes, ils peuvent demander la mise à jour des informations ;
        </li>
        <li>
          le droit de suppression des données : les utilisateurs peuvent demander la suppression de
          leurs données à caractère personnel, conformément aux lois applicables en matière de
          protection des données ;
        </li>
        <li>
          le droit à la limitation du traitement : les utilisateurs peuvent de demander à la
          Plateforme de limiter le traitement des données personnelles conformément aux hypothèses
          prévues par le RGPD ;
        </li>
        <li>
          le droit de s’opposer au traitement des données : les utilisateurs peuvent s’opposer à ce
          que leurs données soient traitées conformément aux hypothèses prévues par le RGPD ;
        </li>
        <li>
          le droit à la portabilité : ils peuvent réclamer que la Plateforme leur remette les
          données personnelles qu&apos;ils ont fournies pour les transmettre à une nouvelle
          Plateforme.
        </li>
      </ul>

      <br />

      <p>
        Vous pouvez exercer ce droit en nous contactant, à l’adresse suivante : 9 rue Angélique
        Verien 92200 Neuilly-sur-Seine. Ou par email, à l’adresse :{' '}
        <a className="text-link" href="mailto:contact@zele-solutions.fr">
          contact@zele-solutions.fr
        </a>
        . Vous pouvez aussi vous adresser à notre délégué à la protection des données : Frédéric
        Courquin,{' '}
        <a className="text-link" href="mailto:fcourquin@zele-solutions.fr">
          fcourquin@zele-solutions.fr
        </a>
        , qui est à votre disposition pour toute question relative à la protection de vos données
        personnelles. Toute demande doit être accompagnée de la photocopie d’un titre d’identité en
        cours de validité signé et faire mention de l’adresse à laquelle l&apos;éditeur pourra
        contacter le demandeur. La réponse sera adressée dans le mois suivant la réception de la
        demande. Ce délai d&apos;un mois peut être prolongé de deux mois si la complexité de la
        demande et/ou le nombre de demandes l&apos;exigent. De plus, et depuis la loi n°2016-1321 du
        7 octobre 2016, les personnes qui le souhaitent, ont la possibilité d’organiser le sort de
        leurs données après leur décès. Pour plus d’information sur le sujet, vous pouvez consulter
        le site Internet de la CNIL :{' '}
        <a className="text-link" href="https://www.cnil.fr" rel="noreferrer" target="_blank">
          https://www.cnil.fr
        </a>
        . Les utilisateurs peuvent aussi introduire une réclamation auprès de la CNIL sur le site de
        la CNIL :{' '}
        <a className="text-link" href="https://www.cnil.fr" rel="noreferrer" target="_blank">
          https://www.cnil.fr
        </a>
        . Nous vous recommandons de nous contacter dans un premier temps avant de déposer une
        réclamation auprès de la CNIL, car nous sommes à votre entière disposition pour régler votre
        problème.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 9 - Utilisation des données</h3>
      <p>
        Les données personnelles collectées auprès des utilisateurs ont pour objectif la mise à
        disposition des services de la Plateforme, leur amélioration et le maintien d&apos;un
        environnement sécurisé. La base légale des traitements est l’exécution du contrat entre
        l’utilisateur et la Plateforme. Plus précisément, les utilisations sont les suivantes :
      </p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>accès et utilisation de la Plateforme par l&apos;utilisateur ;</li>
        <li>gestion du fonctionnement et optimisation de la Plateforme ;</li>
        <li>mise en œuvre d&apos;une assistance utilisateurs ;</li>
        <li>
          vérification, identification et authentification des données transmises par
          l&apos;utilisateur ;
        </li>
        <li>
          personnalisation des services en affichant des publicités en fonction de l&apos;historique
          de navigation de l&apos;utilisateur, selon ses préférences ;
        </li>
        <li>
          prévention et détection des fraudes, malwares (malicious softwares ou logiciels
          malveillants) et gestion des incidents de sécurité ;
        </li>
        <li>gestion des éventuels litiges avec les utilisateurs ;</li>
        <li>
          envoi d&apos;informations commerciales et publicitaires, en fonction des préférences de
          l&apos;utilisateur.
        </li>
      </ul>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 10 - Politique de conservation des données</h3>
      <p>
        La Plateforme conserve vos données pour la durée nécessaire pour vous fournir ses services
        ou son assistance. Dans la mesure raisonnablement nécessaire ou requise pour satisfaire aux
        obligations légales ou réglementaires, régler des litiges, empêcher les fraudes et abus ou
        appliquer nos modalités et conditions, nous pouvons également conserver certaines de vos
        informations si nécessaire, même après que vous ayez fermé votre compte ou que nous
        n&apos;ayons plus besoin pour vous fournir nos services.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">
        Article 11- Partage des données personnelles avec des tiers
      </h3>
      <p>
        Les données personnelles peuvent être partagées avec des sociétés tierces exclusivement dans
        l’Union européenne, dans les cas suivants :
      </p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>
          lorsque l&apos;utilisateur publie, dans les zones de commentaires libres de la Plateforme,
          des informations accessibles au public ;
        </li>
        <li>
          quand l&apos;utilisateur autorise le site web d&apos;un tiers à accéder à ses données ;
        </li>
        <li>
          quand la Plateforme recourt aux services de prestataires pour fournir l&apos;assistance
          utilisateurs, la publicité et les services de paiement. Ces prestataires disposent
          d&apos;un accès limité aux données de l&apos;utilisateur, dans le cadre de
          l&apos;exécution de ces prestations, et ont l&apos;obligation contractuelle de les
          utiliser en conformité avec les dispositions de la réglementation applicable en matière
          protection des données à caractère personnel ;
        </li>
        <li>
          si la loi l&apos;exige, la Plateforme peut effectuer la transmission de données pour
          donner suite aux réclamations présentées contre la Plateforme et se conformer aux
          procédures administratives et judiciaires.
        </li>
      </ul>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 12 - Offres commerciales</h3>
      <p>
        Vous êtes susceptible de recevoir des offres commerciales de l&apos;éditeur. Si vous ne le
        souhaitez pas, veuillez cliquer sur le lien suivant :{' '}
        <a className="text-link" href="mailto:contact@zele-solutions.fr">
          contact@zele-solutions.fr
        </a>
        . Vos données sont susceptibles d’être utilisées par les partenaires de l&apos;éditeur à des
        fins de prospection commerciale, si vous ne le souhaitez pas, veuillez cliquer sur le lien
        suivant :{' '}
        <a className="text-link" href="mailto:contact@zele-solutions.fr">
          contact@zele-solutions.fr
        </a>
        . Si, lors de la consultation du site, vous accédez à des données à caractère personnel,
        vous devez vous abstenir de toute collecte, de toute utilisation non autorisée et de tout
        acte pouvant constituer une atteinte à la vie privée ou à la réputation des personnes.
        L&apos;éditeur décline toute responsabilité à cet égard. Les données sont conservées et
        utilisées pour une durée conforme à la législation en vigueur.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 13 - Cookies</h3>
      <p>
        Qu’est-ce qu’un « cookie » ? Un « Cookie » ou traceur est un fichier électronique déposé sur
        un terminal (ordinateur, tablette, smartphone,…) et lu par exemple lors de la consultation
        d&apos;un site internet, de la lecture d&apos;un courrier électronique, de
        l&apos;installation ou de l&apos;utilisation d&apos;un logiciel ou d&apos;une application
        mobile et ce, quel que soit le type de terminal utilisé (source :{' '}
        <a
          className="text-link"
          href="https://www.cnil.fr/fr/cookies-traceurs-que-dit-la-loi"
          rel="noreferrer"
          target="_blank"
        >
          https://www.cnil.fr/fr/cookies-traceurs-que-dit-la-loi
        </a>
        ). En naviguant sur ce site, des « cookies » émanant de la société responsable du site
        concerné et/ou des sociétés tiers pourront être déposés sur votre terminal. Lors de la
        première navigation sur ce site, une bannière explicative sur l’utilisation des « cookies »
        apparaîtra. Dès lors, en poursuivant la navigation, le client et/ou prospect sera réputé
        informé et avoir accepté l’utilisation desdits « cookies ». Le consentement donné sera
        valable pour une période de treize (13) mois. L&apos;utilisateur a la possibilité de
        désactiver les cookies à partir des paramètres de son navigateur. Toutes les informations
        collectées ne seront utilisées que pour suivre le volume, le type et la configuration du
        trafic utilisant ce site, pour en développer la conception et l&apos;agencement et à
        d&apos;autres fins administratives et de planification et plus généralement pour améliorer
        le service que nous vous offrons.
      </p>
      <br />
      <p>Les cookies suivants sont présents sur ce site :</p>
      <br />
      <p>Cookies Google :</p>
      <ul className="ml-8" style={{ listStyleType: 'disc' }}>
        <li>Google analytics : permet de mesurer l&apos;audience du site ;</li>
        <li>
          Google tag manager : facilite l’implémentation des tags sur les pages et permet de gérer
          les balises Google ;
        </li>
        <li>
          Google Adsense : régie publicitaire de Google utilisant les sites web ou les vidéos
          YouTube comme support pour ses annonces ;
        </li>
        <li>
          Google Dynamic Remarketing : permet de vous proposer de la publicité dynamique en fonction
          des précédentes recherches ;
        </li>
        <li>Google Adwords Conversion : outil de suivi des campagnes publicitaires adwords ;</li>
        <li>DoubleClick : cookies publicitaires de Google pour diffuser des bannières.</li>
      </ul>
      <p>La durée de vie de ces cookies est de treize mois.</p>
      <br />
      <p>
        Pour plus d’informations sur l’utilisation, la gestion et la suppression des « cookies »,
        pour tout type de navigateur, nous vous invitons à consulter le lien suivant :{' '}
        <a
          className="text-link"
          href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser."
          rel="noreferrer"
          target="_blank"
        >
          https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser.
        </a>
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 14 - Photographies et représentation des produits</h3>
      <p>
        Les photographies de produits, accompagnant leur description, ne sont pas contractuelles et
        n&apos;engagent pas l&apos;éditeur.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 15 - Loi applicable</h3>
      <p>
        Les présentes conditions d&apos;utilisation du site sont régies par la loi française et
        soumises à la compétence des tribunaux du siège social de l&apos;éditeur, sous réserve
        d&apos;une attribution de compétence spécifique découlant d&apos;un texte de loi ou
        réglementaire particulier.
      </p>

      <hr className="my-10" />

      <h3 className="mb-8 font-bold">Article 16 - Contactez-nous</h3>
      <p>
        Pour toute question, information sur les produits présentés sur le site, ou concernant le
        site lui-même, vous pouvez laisser un message à l&apos;adresse suivante :{' '}
        <a className="text-link" href="mailto:contact@zele-solutions.fr">
          contact@zele-solutions.fr
        </a>
      </p>
    </div>
  );
}
